export const messages = {
    "shared-link.footer.link.install": "Probar {brandName} gratis",
    "shared-link.footer.link.mobile": "{brandName} para dispositivos móviles",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Datos protegidos",
    "shared-link.password-dialog-box.message": "Especifique la contraseña para acceder a los datos compartidos",
    "shared-link.password-dialog-box.hint.password": "Contraseña",
    "shared-link.password-dialog-box.message.invalid-password": "La contraseña es incorrecta",
    "shared-link.form.button.open": "Abrir",
    "shared-link.page-not-found.title": "Página no encontrada",
    "shared-link.page-not-found.message.main": "No se ha encontrado la página que estaba buscando.",
    "shared-link.page-not-found.message.description": "Puede que el enlace esté desactualizado o que haya escrito la dirección de forma incorrecta.",
    "shared-link.page-not-found.message.error": "Código de error: 404",
    "shared-link.restore-file.label.size": "Tamaño",
    "shared-link.restore-file.button.restore": "Descargar",
    "shared-link.links-table.column.name": "Nombre",
    "shared-link.links-table.column.size": "Tamaño",
    "shared-link.links-table.action.restore": "Descargar",
    "shared-link.links-table.action.restore-all": "Descargar todo",
    "shared-link.side-bar.selected.title:plural": "{count} artículos seleccionados | {count} artículo seleccionado | {count} artículos seleccionados",
    "shared-link.links-table.label.size": "Tamaño",
    "shared-link.links-table.message.empty-folder": "Esta carpeta está vacía"
};
